<script>
  import { getContext } from 'svelte'

  const platform = getContext('platform')

  platform.api.core.render.isAboveTheFold = false
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>